module.exports = __webpack_public_path__ + "img/21.279ab4f3.png";